import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import PrintPage from "../Common/PrintPage";
import BackAction from "../Common/BackAction";

const FlowScreen = (props) => {
  const history = useHistory();

  const handleBackClick = () => {
    if (props.customBackButtonFunc) {
      props.customBackButtonFunc();
    } else {
      history.goBack();
    }
  }

  return (
    <div className={`v2 flow-screen ${props.className || ''}`} data-testid={props.testId || "flow-screen"}>
      {(props.showBackButton || props.showPrintPage) &&
        <div className="flex-row justify-content-between align-items-center">
          {props.showBackButton &&
            <BackAction
              onClick={handleBackClick}
            />
          }
          {props.showPrintPage &&
            <PrintPage />
          }
        </div>
      }
      <div className="relative flow-screen__header-container">
        <h1 className="flow-screen__header">{props.flowTitle}</h1>
        {props.headerAction}
      </div>

      {props.children}
    </div>
  );
};

FlowScreen.propTypes = {
  className: PropTypes.string,
  flowTitle: PropTypes.string,
  children: PropTypes.any,
  showBackButton: PropTypes.bool,
  customBackButtonFunc: PropTypes.func,
  showPrintPage: PropTypes.bool,
  testId: PropTypes.string,
  headerAction: PropTypes.node,
};

export default FlowScreen;
